module.exports = __webpack_public_path__ + "static/footer-middle-wave-36eb69ac249688e9db0886fc4882bbdb.svg";